exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-zoomer[data-v-20389a]{overflow:hidden;transition:background-color .5s}.zoomer[data-v-20389a]{transform-origin:50% 50%;width:100%;height:100%}.zoomer>img[data-v-20389a]{vertical-align:top;-webkit-user-drag:none}.vue-zoomer-gallery[data-v-822895]{position:relative;overflow:hidden;user-select:none;min-width:100px;min-height:100px}.vue-zoomer-gallery>*[data-v-822895]{display:inline-block}.vue-zoomer-gallery.anim .slide[data-v-822895]{transition:left .4s}.slide[data-v-822895]{position:absolute;top:0;object-fit:contain;width:100%;height:100%;-webkit-user-drag:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./resources/vue/css/vue-zoomer.css
// module id = 70
// module chunks = 0